<style src="./Client.scss" lang="scss" scoped></style>
<template>
  <section class="client">
    <content-header path="Cadastro / Cliente"/>

    <form v-on:submit.prevent="searchSubmit">
      <section class="form-box row">
        <textbox
          v-model="searchText"
          label="Buscar cliente"
          placeholder="Digite o nome cliente"
          class="col-9"
          :autofocus="true"/>

        <button class="btn-primary col-3" @click="addNew">
          <icon-add />
          <span class="hide-md">Inserir Novo</span>
        </button>
      </section>
    </form>

    <section class="form-box">
      <client-map :list-data="filteredList"/>
    </section>

    <right-side-panel ref="rspNewClient" title="Novo Cliente" :shortcut="['alt', 'n']">
      <new-client @refresh-list="refreshList" />
    </right-side-panel>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import RightSidePanel from '@/components/foundation/right-side-panel/RightSidePanel'
import { Textbox } from '@/components/primitives'
import { IconAdd, IconEmpty } from '@/components/primitives/icons'
import { NewClient, ClientMap } from './components'
import { GetClientList } from '@/brain/record/client'

let listData = []

export default {
  name: 'Client',
  components: {
    ContentHeader,
    RightSidePanel,
    NewClient,
    ClientMap,
    Textbox,
    IconAdd,
    IconEmpty
  },
  data () {
    return {
      searchText: '',
      filteredList: []
    }
  },
  watch: {
    searchText (pValue) {
      if (pValue.length > 0) {
        const filteredList = listData.filter((pItem) => {
          return pItem.name.toLowerCase().includes(pValue.toLowerCase())
        })
        this.filteredList = this.orderList(filteredList)
      } else {
        this.filteredList = this.orderList(listData)
      }
    }
  },
  mounted () {
    this.loadAll()
  },
  methods: {
    searchSubmit () {},
    refreshList () {
      this.loadAll()
    },
    loadAll () {
      GetClientList()
        .then((result) => {
          const listData = this.orderList(result)
          this.filteredList = listData
        })
    },
    addNew () {
      this.$refs.rspNewClient.showPanel()
    },
    cancelAddNew () {
    },
    addedSuccessful () {
      this.loadAll()
    },
    orderList: (pList) => {
      const r = Object.values(pList).sort((a, b) => {
        return b.shortName.trim() - a.shortName.trim()
      })
      return r
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/client/Client.vue